// extracted by mini-css-extract-plugin
module.exports = {"logoBase":"Logo_logoBase__o4no_","logoWrapper":"Logo_logoWrapper__dwo9X","logoIcon":"Logo_logoIcon__X7zT9","hatImage":"Logo_hatImage__uZalK"};